module.exports = __webpack_public_path__ + "img/20191119152019.d433839b.png";